import React, { FC, useState } from "react";
import { BuddyTeam } from "@jane/lib/src/api/repositories/buddy-teams-repository";
import { Team } from "@jane/lib/src/api/repositories/teams-repository";
import { Select } from "@jane/lib/src/components/form/Select";
import { ApiError, useApiCall } from "../../../lib/src/api";
import { config } from "../config";
import { ErrorBag } from "../../../lib/src/api/call";
import { InputErrors } from "../../../lib/src/components/form/InputErrors";
import { ModalFooter } from "@jane/lib/src/components/layout/ModalProvider";

export const AddBuddyTeamToGroupModal: FC<{ buddy: BuddyTeam; teams: Team[]; reload: () => void }> = ({
  buddy,
  teams,
  reload,
}) => {
  const { buddyTeams: buddyTeamsApi } = useApiCall(config);
  const [team, setTeam] = useState<string>("");
  const teamMap = Object.fromEntries(teams.map((team) => [team.id, `(${team.id}) ${team.name}`]));
  const [errors, setErrors] = useState<ErrorBag>({});

  const add = async (buddyTeamId: string, teamId: string) => {
    await buddyTeamsApi.addTeam(buddyTeamId, String(teamId)).catch((error) => {
      if (error instanceof ApiError && typeof error.errorBag === "object") {
        setErrors(error.errorBag);
      }
    });
    reload();
  };

  return (
    <div>
      <div className={"flex-1"}>
        <Select label={"Team"} options={teamMap} value={team ?? "0"} onChange={setTeam} />
      </div>
      <InputErrors field={"team_id"} errors={errors} />
      <ModalFooter text={"Toevoegen"} onSubmit={() => add(buddy.id, team)} />
    </div>
  );
};

